"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogger = exports.createLogger = exports.VueLogger = void 0;
const vue_1 = require("vue");
const LoggerSymbol = Symbol('vue-logger-plugin');
const levels = ['debug', 'info', 'warn', 'error', 'log'];
const defaultOptions = {
    enabled: true,
    consoleEnabled: true,
    level: 'debug'
};
class VueLogger {
    constructor(options) {
        this.apply(options);
        this._consoleFunctions = levels.filter(lvl => typeof console[lvl] === 'function');
    }
    apply(options) {
        const fallback = this._options || defaultOptions;
        this._options = { ...fallback, ...options };
        this.installHooks(this._options.beforeHooks);
        this.installHooks(this._options.afterHooks);
    }
    debug(...args) {
        this._invoke('debug', ...args);
    }
    info(...args) {
        this._invoke('info', ...args);
    }
    warn(...args) {
        this._invoke('warn', ...args);
    }
    error(...args) {
        this._invoke('error', ...args);
    }
    log(...args) {
        this._invoke('log', ...args);
    }
    _invoke(level, ...args) {
        if (this._options.enabled && levels.indexOf(level) >= levels.indexOf(this._options.level)) {
            this.invokeHooks(this._options.beforeHooks, level, args);
            const msgPrefix = `${level} | `;
            if (this._options.consoleEnabled) {
                if (this._consoleFunctions.indexOf(level) >= 0) {
                    console[level](msgPrefix, ...args);
                }
                else {
                    console.log(msgPrefix, ...args);
                }
            }
            this.invokeHooks(this._options.afterHooks, level, args);
        }
    }
    installHooks(hooks) {
        if (hooks && hooks.length > 0) {
            hooks.forEach(hook => {
                if (hook.install) {
                    try {
                        hook.install(this._options);
                    }
                    catch (err) {
                        console.warn('LoggerHook install failure', err);
                    }
                }
            });
        }
    }
    invokeHooks(hooks, level, argumentArray) {
        if (hooks && hooks.length > 0) {
            const event = { level, argumentArray };
            hooks.forEach(hook => {
                try {
                    hook.run(event);
                }
                catch (err) {
                    console.warn('LoggerHook run failure', err);
                }
            });
        }
    }
    get enabled() {
        return this._options.enabled;
    }
    get level() {
        return this._options.level;
    }
    install(app) {
        app.provide(LoggerSymbol, this);
        app.config.globalProperties.$log = this;
        app.config.globalProperties.$logger = this;
    }
}
exports.VueLogger = VueLogger;
function createLogger(options = {}) {
    return new VueLogger(options);
}
exports.createLogger = createLogger;
function useLogger() {
    const logger = vue_1.inject(LoggerSymbol);
    if (!logger) {
        console.warn('vue-logger-plugin :: useLogger missing inject');
    }
    return logger;
}
exports.useLogger = useLogger;
//# sourceMappingURL=logger.js.map